<template>
  <div class="academy_edu_learn-container" id="EducCenter">
    <div class="academy_edu_learn-wrapper">
      <!-- <header class="academy_edu_learn-hd">
        Quickly Learn Digital Design Software Products Here
      </header> -->
      <article class="academy_edu_learn-bd">
        <div class="edu_learn-item">
          <img
            src="@/assets/images/academy/academy_edu_learn_3.png"
            class="edu_learn-img"
          />
          <div class="edu_learn_content">
            <div
              class="edu_learn_content_wrapper"
              v-scroll-animate="{ animation: 'fadeInUp' }"
            >
              <h2 class="content-label">「江苏南京」授权教育学习中心</h2>
              <p class="content-text">
                为深化产教融合，推动高校教育与行业需求精准对接，狄诺尼与南京工业大学交通运输工程学院携手，以集成交互式道路与立交设计系统-EICAD为实践平台，开展了的道路工程毕业设计实训。
              </p>
            </div>
          </div>
        </div>
        <div class="edu_learn-item trans">
          <img
            src="@/assets/images/academy/academy_edu_learn_1.png"
            class="edu_learn-img"
          />
          <div class="edu_learn_content">
            <div
              class="edu_learn_content_wrapper"
              v-scroll-animate="{ animation: 'fadeInUp' }"
            >
              <h2 class="content-label">「新加坡」授权教育学习中心</h2>
              <p class="content-text">
                综合运用课堂讲授、在线学习、专题讨论、软件实操相结合的方式开展教学，采用了启发式、互动式、变式练习、网络学习平台建立等教学方法，运用了大量实际设计工程案例开展教学。
              </p>
            </div>
          </div>
        </div>
        <div class="edu_learn-item">
          <img
            src="@/assets/images/academy/academy_edu_learn_2.png"
            class="edu_learn-img"
          />
          <div class="edu_learn_content">
            <div
              class="edu_learn_content_wrapper"
              v-scroll-animate="{ animation: 'fadeInUp' }"
            >
              <h2 class="content-label">「印度尼西亚」授权教育学习中心</h2>
              <p class="content-text">
                综合运用课堂讲授、在线学习、专题讨论、软件实操相结合的方式开展教学，采用了启发式、互动式、变式练习、网络学习平台建立等教学方法，运用了大量实际设计工程案例开展教学。
              </p>
            </div>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
export default {
  name: "Solution",
  components: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.academy_edu_learn-container {
  padding: 80px 0;
  background: #fff;
  .academy_edu_learn-wrapper {
    width: 1049px;
    margin: 0 auto;
  }

  .academy_edu_learn-hd {
    margin-bottom: 40px;
    font-weight: bold;
    font-size: 24px;
    color: #1d1d1f;
    line-height: 24px;
    text-align: left;
    font-style: normal;
  }
  .academy_edu_learn-bd {
    font-weight: 400;
    font-size: 18px;
    color: #333;
    line-height: 40px;
    text-align: justify;
    font-style: normal;
  }

  .edu_learn-item {
    display: flex;
    align-items: center;
    height: 298px;
    margin-bottom: 40px;
    .edu_learn-img {
      width: 518px;
      order: 1;
      transition: all 0.3s;
      &:hover {
        transform: scale(1.05);
      }
    }
    .edu_learn_content {
      flex: 1;
      order: 2;
    }
    .edu_learn_content_wrapper {
      padding: 45px 50px 45px 90px;
    }
    .content-label {
      margin-bottom: 24px;
      font-weight: 600;
      font-size: 24px;
      color: #000000;
      line-height: 24px;
      text-align: left;
    }
    .content-text {
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      line-height: 32px;
      text-align: justify;
      text-indent: 2em;
    }

    &.trans {
      // margin-bottom: 0;
      .edu_learn_content {
        order: 1;
      }
      .edu_learn-img {
        order: 2;
      }
      .edu_learn_content_wrapper {
        padding: 45px 90px 45px 0px;
      }
    }
  }
}
</style>
